import React from 'react';
import {
    Edit,
    TextField,
    ReferenceField,
    SimpleForm,
    ReferenceInput,
    SelectInput,
    FormDataConsumer,
} from 'react-admin';

import SgxDateField from '../components/sgxDateField';

const HistoricoValidacionesEdit = (props) => (
    <Edit mutationMode="optimistic" {...props}>
        <SimpleForm>
            <TextField source="id" />
            <FormDataConsumer>
                {({ formData }) => formData.auditable ?
                    <ReferenceInput
                        source="estado"
                        reference="estado-validaciones"
                        label="Estado"
                    >
                        <SelectInput optionText="descripcion" optionValue="id" />
                    </ReferenceInput>
                    :
                    <ReferenceInput
                        source="estado"
                        reference="estado-validaciones"
                        label="Estado"
                    >
                        <SelectInput optionText="descripcion" optionValue="id" disabled/>
                    </ReferenceInput>
                }
            </FormDataConsumer>
            <TextField source="numeroAfiliado"
                       label="resources.auditable-validaciones.fields.numeroAfiliado"/>
            <ReferenceField
                source="idPrestacion"
                reference="prestaciones"
                label="resources.auditable-validaciones.fields.prestacion"
            >
                <TextField source="descripcion"/>
            </ReferenceField>
            <SgxDateField source="fechaPrestacion" label="resources.auditable-validaciones.fields.fechaPrestacion"/>
        </SimpleForm>
    </Edit>
);

export default HistoricoValidacionesEdit;
